var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgS3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C3123",
    fillRule: "evenodd",
    d: "M5 9.462v21.083l2.354 1.194.014-.017V8.277l-.014-.016z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E05243",
    fillRule: "evenodd",
    d: "M20.395 28.68 7.368 31.74V8.26l13.027 2.994z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C3123",
    fillRule: "evenodd",
    d: "m14.474 23.617 5.461.687.034-.078.031-8.852-.065-.07-5.461.678zM20 28.708l12.612 3.031.02-.031V8.282l-.02-.021L20 11.288z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E05243",
    fillRule: "evenodd",
    d: "M25.526 23.617 20 24.304v-9l5.526.678z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E1F18",
    fillRule: "evenodd",
    d: "M25.526 12.384 20 13.348l-5.525-.964L19.992 11z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2B0A9",
    fillRule: "evenodd",
    d: "M25.526 27.584 20 26.652l-5.525.932L19.992 29z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C3123",
    fillRule: "evenodd",
    d: "m19.956 2-5.482 2.76v7.805l5.482-1.365.044-.014V2.037z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E05243",
    fillRule: "evenodd",
    d: "M20 2v9.2l5.526 1.365V4.76z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C3123",
    fillRule: "evenodd",
    d: "M14.474 35.24 19.92 38l.058-.16.022-8.948-.08-.092-5.446-1.365v7.806Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E05243",
    fillRule: "evenodd",
    d: "M20 28.8V38l5.526-2.76v-7.805zm12.632 2.94L35 30.538V9.462L32.632 8.26v23.478Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgS3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/s3.26c21f5c.svg";